import { useState, useEffect } from "react";
import Spinner from "../../components/ui/Spinner.component";
import UserDetailsTable from "../../components/ui/UserDetailsTable.component";
import Breadcrumb from "../../components/ui/Breadcrumb.component";
import { fetchAccountData } from "./accountApi";
import { formatPhoneNumber } from "./formatPhoneNumber";

export const AccountPage = () => {
  const [accountData, setAccountData] = useState(null);
  const [accountState, setAccountState] = useState(null);
  const [infoProvided, setInfoProvided] = useState(false);

  const token = sessionStorage.getItem("token");

  useEffect(() => {
    const fetchData = async () => {
      try {
        const { responseData, responseState } = await fetchAccountData(token);
        setAccountData(responseData.data);
        setAccountState(responseState.data);
      } catch (error) {
        console.error(error);
      }
    };
    fetchData();
  }, [token]);

  useEffect(() => {
    if (accountData && accountData.data.phone) {
      setInfoProvided(true);
    }
  }, [accountData]);

  if (!accountData && !accountState) {
    return (
      <div
        className="w-full h-screen "
        style={{ height: "calc(100vh - 66px)" }}
      >
        <div className="flex relative bg-black/[.27]  h-full">
          <div>
            <Breadcrumb
              segments={["Home", "Account"]}
              paths={["/", "/account"]}
            />
          </div>
          <div className="absolute top-1/2 left-1/2">
            <Spinner />
          </div>
        </div>
      </div>
    );
  }

  const email = accountData.data.email;
  const name = accountData.data.first_name + " " + accountData.data.last_name;
  const phone = accountData.data.phone
    ? formatPhoneNumber(accountData.data.phone)
    : "Information wasn't provided";
  const npi = accountData.data.npi;
  const organization = accountData.data.organization.name;

  return (
    <div className="w-full">
      <Breadcrumb segments={["Home", "Account"]} paths={["/", "/"]} />
      <div className="flex items-center mt-[26px] ml-5 mb-9 md:hidden">
        <img
          src={`${
            accountData && accountData.profile_picture
              ? accountData.profile_picture
              : "https://www.pngitem.com/pimgs/m/78-786420_icono-usuario-joven-transparent-user-png-png-download.png"
          }`}
          className="w-[77px] rounded-[50%]"
          alt="user_image"
        />
        <p className="ml-5 font-rubik font-medium text-lg">{name}</p>
      </div>
      <div className="px-4.5 md:pl-13 md:pr-16 overflow-x-auto">
        <h2 className="hidden md:flex text-[1.75rem] font-rubik font-medium pl-0.5 md:pl-8 md:mt-7 md:mb-4">
          Account overview
        </h2>

        <UserDetailsTable
          name={name}
          email={email}
          phone={phone}
          npi={npi}
          infoProvided={infoProvided}
          organization={organization}
        />
      </div>
      <div className="m-5 my-12 md:m-0 md:ml-[84px] md:my-[36px]">
        <button className="bg-gr px-11 py-3.5 font-semibold text-base bg-transparent text-[#338CC7] rounded-[12px] border border-[#338CC7]">
          Edit profile
        </button>
        <h2 className="text-[1.375rem] font-rubik font-medium mt-14 md:mt-12">
          Manage your members
        </h2>
        <p className="text-base mt-4 font-rubik font-normal">
          Do you want to add or remove members of your organization?
        </p>
        <button className="bg-gr px-5 mt-10 py-2 font-semibold text-base bg-transparent text-[#338CC7] rounded-[12px] border border-[#338CC7]">
          Edit organization
        </button>
      </div>
    </div>
  );
};
